/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClmClaimRisksResponseDto } from '../models/clm-claim-risks-response-dto';


/**
 * the ClaQueryReadRisks API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaQueryReadRisksService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation claimClaimIdRisksGet
   */
  static readonly ClaimClaimIdRisksGetPath = '/claim/{claimId}/risks';

  /**
   * Get risks by product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimClaimIdRisksGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdRisksGet$Response(params: {
    claimId: string;
    language?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ClmClaimRisksResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClaQueryReadRisksService.ClaimClaimIdRisksGetPath, 'get');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.query('language', params.language, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClmClaimRisksResponseDto>;
      })
    );
  }

  /**
   * Get risks by product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimClaimIdRisksGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdRisksGet(params: {
    claimId: string;
    language?: string;
  },
  context?: HttpContext

): Observable<ClmClaimRisksResponseDto> {

    return this.claimClaimIdRisksGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<ClmClaimRisksResponseDto>) => r.body as ClmClaimRisksResponseDto)
    );
  }

}
